<template>
  <b-container class="logo-maker-banner-container my-4" fluid>
    <b-row class="w-100 container" cols="1" cols-md="2">
      <b-col class="image-container">
        <picture>
          <source
            srcset="https://cdn.vexels.com/img/logo-maker-lottie-replace.png?fmt=webp&w=300"
            type="image/webp"
            media="(max-width: 992px)"
          />
          <source
            srcset="https://cdn.vexels.com/img/logo-maker-lottie-replace.png?fmt=webp"
            type="image/webp"
          />
          <source
            srcset="https://cdn.vexels.com/img/logo-maker-lottie-replace.png"
            type="image/png"
          />
          <img
            class="img-fluid"
            src="https://cdn.vexels.com/img/logo-maker-lottie-replace.png"
            :alt="$t('home.design.businessLogoMaker.illustrationAlt')"
            width="100%"
            height="100%"
            loading="lazy"
          />
        </picture>
      </b-col>
      <b-col>
        <b-container class="" fluid>
          <b-row cols="1" class="w-100 text-center">
            <b-col>
              <h2 class="title">{{ $t('home.design.businessLogoMaker.title') }}</h2></b-col
            >
            <b-col
              ><h3 class="subtitle">{{ $t('home.design.businessLogoMaker.subtitle') }}</h3></b-col
            >
            <b-col class="description">{{ $t('home.design.businessLogoMaker.description') }}</b-col>
            <b-col class="button">
              <Button
                color="design-inverted-color"
                :blank="true"
                to="https://logomaker.vexels.com/"
              >
                {{ $t('home.design.businessLogoMaker.getStarted') }}
              </Button>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Button from 'UI/Button';
export default {
  components: {
    Button
  }
};
</script>

<style lang="scss" scoped>
.logo-maker-banner-container {
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url('https://cdn.vexels.com/img/logomakerbg.png');
  background-size: cover;
  padding: 35px 0;
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 15px;
}
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
  }
}
.title {
  text-align: left;
  font-weight: 500;
  color: white;
  font-size: 2.3em;
  margin-bottom: 10px;
}
.subtitle {
  text-align: left;
  font-weight: 400;
  color: white;
  font-size: 1.5em;
  margin-bottom: 10px;
}
.description {
  text-align: left;
  font-weight: 400;
  color: white;
  font-size: 0.8em;
  margin-bottom: 50px;
}
.button {
  text-align: left;
}
</style>
